/* title: 登录授权 */
import renderToApp from '../../renderToApp';
import reducer from '../../reducer/authorization/index';
import authorizationPage from '../../container/authorization/indexPage';

const render = renderToApp(reducer);

render(authorizationPage);
if (module.hot) {
	module.hot.accept('../../container/authorization/indexPage', () => {
		const NextApp = require('../../container/authorization/indexPage').default;
		render(NextApp)
	});
}


// WEBPACK FOOTER //
// ./src/main/oauth/index.js